import { camo } from './camo';
import { flannel } from './flannel';
import { modern } from './modern';
import { patriotic } from './patriotic';
import { pinstripe } from './pinstripe';
import { throwback } from './throwback';
import { traditional } from './traditional';
import { seamhead } from './seamhead';
import { awareness } from './awareness';
import { triton_connect } from './triton_connect';

export const baseball = {
  traditional,
  throwback,
  modern,
  pinstripe,
  flannel,
  patriotic,
  camo,
  seamhead,
  awareness,
  triton_connect,
};
